import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { DocumentoDetalleSalida } from '../../model/documento-detalle-salida';
import { Consorcio } from '../../model/consorcio';
import { Sucursal } from '../../model/sucursal';
import { Articulo } from '../../model/articulo';
import { ArticuloBuscarComponent } from '../../components/articulo-buscar/articulo-buscar.component';
import { DocumentoDetalleSalidaService } from '../../services/documento-detalle-salida.service';


@Component({
  selector: 'app-documento-salida-detalle',
  templateUrl: './documento-salida-detalle.component.html',
  styleUrls: ['./documento-salida-detalle.component.css']
})
export class DocumentoSalidaDetalleComponent implements OnInit {

  @ViewChild(ArticuloBuscarComponent) buscarArticulo: ArticuloBuscarComponent;


  @Input() consorcio: Consorcio;
  @Input() sucursal: Sucursal;


  public detalle: DocumentoDetalleSalida;
  public detalles: DocumentoDetalleSalida[];

  public articulo: Articulo;

  public codigoArticulo: string;
  public nombreArticulo: string;
  public id: number;


  public codigoDocumento: string;

  constructor(private _detalle: DocumentoDetalleSalidaService) { }

  ngOnInit() {

     
   
  }

/*
  editarRegistro (detalle: DocumentoDetalleSalida){
    this.detalle = detalle;
    this.buscarArticulo.cargarArticulo(detalle.codigoArticulo);
  }

  articuloSeleccionado(event) {
    this.codigoArticulo = event.codigoArticulo;
    this.articulo = event;
  }

  cargarDetalles(codigoConsorcio:string, codigoDocumento:string) {

    var query: any;

    query = { "codigoConsorcio":  this.consorcio.codigoConsorcio, "codigoDocumento":  codigoDocumento };
    
    this._detalle.getDetalleByDocumento(query)
      .subscribe(
      data => {
        this.detalles = data;
        console.log(data);},
      err => {
        console.log(err);
      });
  }

  guardarDetalle() {

    if (this.detalles.length > 0) 
      if ((this.detalle.id === 0) || (this.detalle.id === undefined)) {
        this.detalle.id = Math.max.apply(Math, this.detalles.map(function (o) { return o.id; })) + 1;
      }

    } else {
      this.detalle.id = 1;
    }

    this.detalle.codigoArticulo = this.articulo.codigoArticulo;
    this.detalle.nombreArticulo = this.articulo.nombreLargo;

    if (this.detalle.dua === undefined) {
      this.detalle.dua = "";
    }

    if (this.detalle.contenedor === undefined) {
      this.detalle.contenedor = "";
    }

    if (this.detalle.lote === undefined) {
      this.detalle.lote = "";
    }

    if (this.detalle.referencia1 === undefined) {
      this.detalle.referencia1 = "";
    }

    if (this.detalle.referencia2 === undefined) {
      this.detalle.referencia2 = "";
    }

    this.detalle.codigoConsorcio = this.consorcio.codigoConsorcio;
    this.detalle.codigoDocumento = this.codigoDocumento;

    this.detalles.push(this.detalle);

    this.detalle = new DocumentoDetalleSalida();
    this.articulo = new Articulo();
    this.buscarArticulo.limpiarDatos();



  }*/

}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/components/documento-salida-detalle/documento-salida-detalle.component.ts